<template>
  <div class="hello">
    <span>{{ msg }}</span>
    <div>
      <div>
        <el-button @click="this.$router.push('/pm/list')">项目列表</el-button>
        <el-button @click="this.$router.push('/pm/detail')">项目进度管理</el-button>
      </div>
    </div>
    <el-divider></el-divider>
  </div>
</template>

<script>
export default {
  name: 'TestRouter',
  props: {
    msg: String
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  text-align: center;
}
</style>
